export interface WidgetSMSAllowanceDTO {
  companyName?            : string; //CRN_20260605 - Owner of allowance
  remainingMonthlyQuantity: number | null;
  totalMonthlyQuantity    : number | null;
  usedMonthlyQuantity     : number | null;
};

export function WidgetSMSAllowanceDTO_EmptyObject(): WidgetSMSAllowanceDTO {
  return {
    remainingMonthlyQuantity: null,
    totalMonthlyQuantity    : null,
    usedMonthlyQuantity     : null
  };
};
